<template>
  <div>
    <b-collapse visible>
      <p class="mb-2">
        <label> Por favor consulte o registre los productos a comparar </label>
      </p>
    </b-collapse>
    <b-row>
      <b-col sm="4">
        <b-form-group>
          <label>Nombre o sinónimo</label>
          <b-form-input
            v-model="filtroProductosPagos.buscar"
            id="producto1_nombre"
            name="producto1_nombre"
            type="text"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group>
          <label>Fabricante</label>
          <el-select
            id="id_fabricante"
            name="id_fabricante"
            v-model="filtroProductosPagos.id_fabricante"
            filterable
            clearable
            no-data-text="No hay datos que coincidan"
            no-match-text="No hay datos que coincidan"
          >
            <el-option
              v-for="fabricante in fabricantes"
              :key="fabricante.id"
              :label="fabricante.nombre"
              :value="fabricante.id"
            >
            </el-option>
          </el-select>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group>
          <label>Estado</label>
          <el-select
            id="id_estado"
            name="id_estado"
            v-model="filtroProductosPagos.id_estado"
            filterable
            clearable
            no-data-text="No hay datos que coincidan"
            no-match-text="No hay datos que coincidan"
          >
            <el-option
              v-for="estado in estados"
              :key="estado.value"
              :label="estado.text"
              :value="estado.value"
            >
            </el-option>
          </el-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <b-button variant="primary" @click="buscarProductosPagos">
          <i class="fa fa-search fa-lg"></i>
          Buscar
        </b-button>
        <b-button class="ml-5" variant="danger" @click="resetFiltros">
          <i class="fa fa-eraser fa-lg"></i>
          Limpiar
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col v-if="tipoMatriz.tipo != 'transporte'">
        <b-form-group v-if="!registrarProducto1">
          <b-button
            variant="info"
            v-text="'Registrar producto 1'"
            @click="registrarProducto(1)"
          />
        </b-form-group>
        <b-form-group v-else>
          <b-button
            variant="info"
            v-text="'Consultar producto 1'"
            @click="consultarProducto(1)"
          />
        </b-form-group>
      </b-col>
      <b-col v-if="tipoMatriz.tipo != 'transporte'">
        <b-form-group v-if="!registrarProducto2">
          <b-button
            variant="info"
            v-text="'Registrar producto 2'"
            @click="registrarProducto(2)"
          />
        </b-form-group>
        <b-form-group v-else>
          <b-button
            variant="info"
            v-text="'Consultar producto 2'"
            @click="consultarProducto(2)"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6" v-if="registrarProducto1">
        <b-form-group>
          <label>Ingrese el nombre del producto 1</label>
          <b-form-input
            @keyup="limpiarCampoProductoNuevo(1)"
            :disabled="producto1.id != ''"
            name="producto1name"
            type="text"
            v-model="producto1.nombre"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="6" v-if="registrarProducto2">
        <b-form-group>
          <label>Ingrese el nombre del producto 2</label>
          <b-form-input
            @keyup="limpiarCampoProductoNuevo(2)"
            :disabled="producto2.id != ''"
            name="producto2name"
            type="text"
            v-model="producto2.nombre"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6" v-if="registrarProducto1">
        <b-form-group>
          <label>Fabricante del producto 1</label>
          <el-select
            :disabled="producto1.nombre == ''"
            clearable
            id="fabricante1"
            name="fabricante1"
            v-model="producto1.fabricante_id"
            filterable
            no-data-text="No hay datos que coincidan"
            no-match-text="No hay datos que coincidan"
          >
            <el-option
              v-for="fabricante in fabricantes"
              :key="fabricante.id"
              :value="fabricante.id"
              :label="fabricante.nombre"
            ></el-option>
          </el-select>
        </b-form-group>
      </b-col>
      <b-col sm="6" v-if="registrarProducto2">
        <b-form-group>
          <label>Fabricante del producto 2</label>
          <el-select
            :disabled="producto2.nombre == ''"
            clearable
            id="fabricante2"
            name="fabricante2"
            v-model="producto2.fabricante_id"
            filterable
            no-data-text="No hay datos que coincidan"
            no-match-text="No hay datos que coincidan"
            data-vv-as=" "
          >
            <el-option
              v-for="fabricante in fabricantes"
              :key="fabricante.id"
              :value="fabricante.id"
              :label="fabricante.nombre"
            ></el-option>
          </el-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6" v-if="registrarProducto1">
        <b-form-group>
          <label>Estado del producto 1</label>
          <el-select
            :disabled="producto1.nombre == ''"
            v-if="!producto1.id"
            clearable
            v-model="producto1.estado_id"
            filterable
            no-data-text="No hay datos que coincidan"
            no-match-text="No hay datos que coincidan"
            data-vv-as=" "
            v-validate="'required'"
          >
            <el-option
              v-for="estado in estados"
              :key="estado.value"
              :value="estado.value"
              :label="estado.text"
            ></el-option>
          </el-select>
        </b-form-group>
      </b-col>
      <b-col sm="6" v-if="registrarProducto2">
        <b-form-group>
          <label>Estado del producto 2</label>
          <el-select
            :disabled="producto2.nombre == ''"
            clearable
            v-model="producto2.estado_id"
            filterable
            no-data-text="No hay datos que coincidan"
            no-match-text="No hay datos que coincidan"
            data-vv-as=" "
            v-validate="'required'"
          >
            <el-option
              v-for="estado in estados"
              :key="estado.value"
              :value="estado.value"
              :label="estado.text"
            ></el-option>
          </el-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <b-button @click="$emit('volverMatriz')"> Volver </b-button>
      </b-col>
      <b-col sm="6">
        <b-button
          class="float-right"
          v-if="tipoMatriz.tipo == 'almacenamiento'"
          variant="primary"
          @click="avanzarFormulario()"
          :disabled="disabledProductos"
        >
          Completar productos
        </b-button>
        <b-button
          class="float-right"
          variant="primary"
          @click="visualizarUNSga"
          :disabled="disabledProductos"
          v-text="'Siguiente'"
          v-else
        />
      </b-col>
    </b-row>
    <div class="mt-5">
      <b-table
        responsive
        hover
        :items="selectedEmpresa.productos"
        :fields="columnas"
      >
        <template v-slot:cell(asignarProd1)="data">
          <b-form-radio
            :disabled="registrarProducto1"
            :value="true"
            :checked="data.item.id === producto1.id"
            @change="obtenerProducto(data, 1)"
          ></b-form-radio>
        </template>
        <template v-slot:cell(asignarProd2)="data">
          <b-form-radio
            :disabled="registrarProducto2"
            :value="true"
            :checked="data.item.id === producto2.id"
            @change="obtenerProducto(data, 2)"
          ></b-form-radio>
        </template>
        <template v-slot:cell(ubicaciones)="data">
          <a
            v-b-tooltip.hover
            size="sm"
            v-b-modal.modal-lg
            class="botonProduct"
            @click="visualizarUbicaciones(data)"
          >
            <i class="fa fa-list-alt fa-lg ml-1"></i>
          </a>
        </template>
      </b-table>
      <b-row>
        <b-col>
          <b-button @click="$emit('volverMatriz')"> Volver </b-button>
        </b-col>
        <b-col>
          <el-pagination
            @size-change="setPerPagePagination"
            @current-change="setPagePagination"
            v-model="filtroProductosPagos.page"
            class="float-right"
            :current-page="filtroProductosPagos.page"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="filtroProductosPagos.perPage"
            layout="total,sizes,prev,pager,next"
            :total="total.productosPagos"
          >
          </el-pagination>
        </b-col>
      </b-row>
      <b-modal
        hide-footer
        v-model="modalUbicaciones"
        size="xl"
        :title="'Ubicaciones asociadas'"
      >
        <b-card>
          <center>
            <b-form-group label="Filtrar" horizontal>
              <b-form-input v-model="filterText" />
            </b-form-group>
          </center>
          <el-tree
            ref="tree"
            :data="ubicacionesAsignadas"
            show-checkbox
            node-key="id"
            :filter-node-method="filterNode"
            :default-checked-keys="selecionadosIds"
            default-expand-all
            :expand-on-click-node="false"
            check-strictly
            empty-text="Sin ubicaciones asignadas"
          >
          </el-tree>
        </b-card>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import Vue from "vue";
import UbicacionProductoEmpresa from "../empresa/productos/ubicacionProductoEmpresa";

import VeeValidate, { Validator } from "vee-validate";
import es from "vee-validate/dist/locale/es";

Vue.use(VeeValidate, {
  fieldsBagName: "vvFields",
  events: "change",
});

Validator.localize("es", es);

export default {
  name: "general",
  data() {
    return {
      selecionadosIds: [],
      ubicacionHija: "",
      filterText: "",
      registrarProducto1: false,
      registrarProducto2: false,
      modalUbicaciones: false,
      defaultProps: {
        disabled: "disabled",
      },
      ubicacionesAsignadas: [],
      productosSeleccionados: {
        producto1: false,
        producto2: false,
      },
      columnas: [
        {
          key: "nombre",
          label: "Nombre",
          sortable: true,
          thStyle: {
            "min-width": "150px !important",
          },
        },
        {
          key: "sinonimos",
          label: "Sinónimos",
          sortable: true,
          thStyle: {
            "min-width": "150px !important",
          },
        },
        {
          key: "lista_estado.lista",
          label: "Estado",
          sortable: true,
          thStyle: {
            "min-width": "100px !important",
            width: "100px !important",
          },
        },
        {
          key: "fabricante.nombre",
          label: "Fabricante",
          sortable: true,
          thStyle: {
            "min-width": "150px !important",
            width: "150px !important",
          },
        },
        {
          key: "asignarProd1",
          label: "Producto 1",
          thStyle: {
            "min-width": "110px !important",
            width: "110px !important",
          },
        },
        {
          key: "asignarProd2",
          label: "Producto 2",
          thStyle: {
            "min-width": "110px !important",
            width: "110px !important",
          },
        },
        {
          key: "ubicaciones",
          label: "Ubicaciones",
          thStyle: {
            "min-width": "110px !important",
            width: "110px !important",
          },
        },
      ],
    };
  },
  async created() {
    this.resetProductos();
    this.load(true);
    await this.getProductosPagos();
    this.load(false);
  },
  components: {
    UbicacionProductoEmpresa,
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    async visualizarUNSga() {
      let id_productos = [
        { producto1_id: this.producto1.id },
        { producto2_id: this.producto2.id },
      ];
      this.load(true);
      for await (let prod of id_productos) {
        await this.getUnSgaProductos(prod);
      }
      this.load(false);
      this.setPaso(1);
    },
    async resetFiltros() {
      this.resetFiltroProductosPagos();
      this.load(true);
      await this.getProductosPagos();
      this.load(false);
    },
    marcarProducto(id, n) {
      if (n === 1 && id == this.producto1.id) {
        return true;
      }

      if (n === 2 && id == this.producto2.id) {
        return true;
      }

      return false;
    },
    obtenerUbicaciones() {
      let self = this;
      this.ubicacionesAsignadas.forEach((ubicacion, i) => {
        if (ubicacion.children.length) {
          let bool = ubicacion.checked ? 1 : 0;
          self.obtenerUbicacionesAsignadas(ubicacion, bool, i);
        }
      });

      let index = this.ubicacionesAsignadas.length - 1;
      while (index >= 0) {
        if (!this.ubicacionesAsignadas[index].checked) {
          self.ubicacionesAsignadas.splice(index, 1);
        }

        index -= 1;
      }
      this.ubicacionesAsignadas.forEach((ubicacion) => {
        self.removerUbicacionesDesignadas(ubicacion);
      });
    },
    removerUbicacionesDesignadas(ubicacion) {
      let index = ubicacion.children.length - 1;
      while (index >= 0) {
        if (!ubicacion.children[index].checked) {
          ubicacion.children.splice(index, 1);
        } else {
          if (ubicacion.children[index].children.length > 0) {
            this.removerUbicacionesDesignadas(ubicacion.children[index]);
          }
        }
        index -= 1;
      }
    },
    obtenerUbicacionesAsignadas(ubicacion, checked, indicePadre) {
      let self = this;
      ubicacion.children.forEach((hijo, i, object) => {
        if (hijo.checked || checked == 1) {
          if (hijo.checked && checked == 0) {
            this.ubicacionesAsignadas[indicePadre].checked = true;
            this.asignarUbicacionesPadres(
              hijo.get_parent[0].id,
              this.ubicacionesAsignadas[indicePadre]
            );
          }
          hijo.checked = true;
          if (hijo.children.length > 0) {
            self.obtenerUbicacionesAsignadas(hijo, 1, indicePadre);
          }
        } else if (!hijo.checked && checked == 0) {
          if (hijo.children.length > 0) {
            self.obtenerUbicacionesAsignadas(hijo, 0, indicePadre);
          }
        }
      });
    },
    asignarUbicacionesPadres(id, ubicaciones) {
      ubicaciones.children.forEach((ubicacion) => {
        if (ubicacion.id == id) {
          ubicacion.checked = true;
          if (ubicacion.get_parent.length) {
            this.asignarUbicacionesPadres(
              ubicacion.get_parent[0].id,
              ubicaciones
            );
          }
        } else {
          this.asignarUbicacionesPadres(id, ubicacion);
        }
      });
    },
    async visualizarUbicaciones(prod) {
      let producto = prod.item.id;
      let data = {};
      data.empresa = this.selectedEmpresa.id;
      data.producto = parseInt(producto);
      data.asigEmpresa = true;

      this.setInfo(data);
      this.load(true);
      await this.getUbicacionProd(this.info);
      this.load(false);
      this.selecionadosIds = [];
      this.pusherSeleccionados(this.ubicaciones);
      this.ubicacionesAsignadas = this.ubicaciones;
      /* this.ubicaciones.forEach((element) => {
        this.ubicacionesAsignadas.push(element);
      });
      console.log( this.ubicacionesAsignadas); */

      this.modalUbicaciones = true;
    },
    pusherSeleccionados(data) {
      let ubicaciones = data;
      ubicaciones.forEach((element) => {
        element.disabled = true;
        if (element.get_product.length) {
          this.selecionadosIds.push(element.id);
        }
        if (element.children.length) {
          this.pusherSeleccionados(element.children);
        }
      });
    },

    registrarProducto(n) {
      if (n === 1) {
        this.productosSeleccionados.producto1 = false;
        this.producto1.id = "";
        this.producto1.estado_id = "";
        this.producto1.fabricante_id = "";
        this.producto1.adjuntos = [];
        this.registrarProducto1 = true;
      } else {
        this.productosSeleccionados.producto2 = false;
        this.producto2.id = "";
        this.producto2.estado_id = "";
        this.producto2.fabricante_id = "";
        this.producto2.adjuntos = [];
        this.registrarProducto2 = true;
      }
    },
    consultarProducto(n) {
      if (n === 1) {
        this.producto1.nombre = "";
        this.producto1.estado_id = "";
        this.producto1.fabricante_id = "";
        this.registrarProducto1 = false;
      } else {
        this.producto2.nombre = "";
        this.producto2.estado_id = "";
        this.producto2.fabricante_id = "";
        this.registrarProducto2 = false;
      }
    },
    obtenerProducto(data, n) {
      let prod = {
        id: data.item.id,
        estado_id: data.item.estado,
        fabricante_id: data.item.id_fabricante,
        adjuntos: data.item.adjuntos,
        nombre: data.item.nombre,
      };
      if (n === 1) {
        this.setProducto1(prod);
      } else {
        this.setProducto2(prod);
      }
    },
    async setPagePagination(page) {
      let filtro = { cantidad: page, tipo: "productosPagos" };
      this.load(true);
      await this.setPage(filtro);
      await this.getProductosPagos();
      this.load(false);
    },
    async setPerPagePagination(perPage) {
      let filtro = { cantidad: perPage, tipo: "productosPagos" };
      this.load(true);
      this.setPerPage(filtro);
      await this.getProductosPagos();
      this.load(false);
    },
    async buscarProductosPagos() {
      this.load(true);
      let data = { tipo: "productosPagos", cantidad: 1 };
      this.setPage(data);
      await this.getProductosPagos();
      this.load(false);
    },
    async avanzarFormulario() {
      if (this.producto1.estado_id != this.producto2.estado_id) {
        this.load(true);
        let data = { producto1: this.producto1, producto2: this.producto2 };
        await this.guardarComparativaProductos(data);
        if (!this.error.length) {
          this.resetProductos();
        }
        this.load(false);
      } else if (!this.producto1.id || !this.producto2.id) {
        let id_productos = new FormData();
        if (this.producto1.id) {
          id_productos.append("producto1_id", this.producto1.id);
        }

        if (this.producto2.id) {
          id_productos.append("producto2_id", this.producto2.id);
        }

        this.load(true);
        if (this.producto2.id || this.producto1.id) {
          await this.getUnSgaProductos(id_productos);
        }
        await this.cargarRiesgos();
        this.setPaso(1);
        this.load(false);
      } else {
        let id_productos = [
          { producto1_id: this.producto1.id },
          { producto2_id: this.producto2.id },
        ];
        this.load(true);
        for await (let prod of id_productos) {
          await this.getUnSgaProductos(prod);
        }
        await this.validarUNSgaProductos();
        this.load(false);
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    asignacionUbicaciones(id) {
      let contratistas = [];

      this.ubicacionesContratista.map((uc) => {
        let asignado = uc.ubicaciones.find(
          (u) => u.id_ubicacion_empresa_contratante === id
        );
        if (!!asignado) {
          contratistas.push({ nombre: uc.contratista.nombre, checked: true });
        }
      });
      return contratistas;
    },
    ...mapActions("matrizCompatibilidad", [
      "guardarComparativaProductos",
      "getUnSgaProductos",
      "cargarRiesgos",
      "getProductosPagos",
      "validarUNSgaProductos",
    ]),
    ...mapActions("asignacionproductos", ["getUbicacionProd"]),
    ...mapMutations("matrizCompatibilidad", [
      "setPaso",
      "resetProductos",
      "setPerPage",
      "setPage",
      "limpiarCamposProductoIngresado",
      "limpiarCampoProductoNuevo",
      "setProducto1",
      "setProducto2",
      "resetFiltroProductosPagos",
    ]),
    ...mapMutations("asignacionproductos", ["setInfo"]),
    ...mapMutations("dashboard", ["load"]),
  },
  computed: {
    disabledProductos: function () {
      if (
        (!this.producto1.nombre.length ||
          !this.producto1.fabricante_id ||
          !this.producto1.estado_id) &&
        !this.producto1.id
      ) {
        return true;
      }
      if (
        (!this.producto2.nombre.length ||
          !this.producto2.fabricante_id ||
          !this.producto2.estado_id) &&
        !this.producto2.id
      ) {
        return true;
      }
      return false;
    },
    ...mapGetters("matrizCompatibilidad", ["getModalMatriz"]),
    ...mapState("matrizCompatibilidad", [
      "total",
      "selectedEmpresa",
      "producto1",
      "producto2",
      "preguntas",
      "compatibilidad_un",
      "paso",
      "estados",
      "error",
      "modalMatriz",
      "filtroProductosPagos",
      "tipoMatriz",
    ]),
    ...mapState("productos_emp", [
      "seleccionado",
      "marcados",
      "ubicacionesContratista",
    ]),
    ...mapState("productos", ["fabricantes"]),
    ...mapState("asignacionproductos", ["info", "ubicaciones"]),
  },
};
</script>
<style scoped>
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #097b83;
  border-color: #dcdfe6;
}
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #ffffff;
  width: 5px;
  margin-top: 2px;
  margin-left: 1px;
}
.el-checkbox__inner {
  display: inline-block;
  position: relative;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  background-color: #fff;
  margin-top: 10px;
}
.el-checkbox__input.is-checked .el-checkbox__inner::after {
    border-color: #ffffff;
    margin-top: 1px;
    margin-left: 2px;
}
</style>
